<template>
    <div class="acsave acccont">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            {{$t('account.account_security')}}
        </div>
        <div>
            <div class="texac">
                <div class="formbox">
                    <div class="accctit" v-if="!isApp">
                        {{$t('account.account_security')}}
                    </div>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item :label="$t('account.email')" prop="email">
                            <el-input prefix-icon="el-icon-message" type="text" v-model="ruleForm.email"
                                      :placeholder="$t('account.input_your_email')" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.password')" prop="password">
                            <el-input prefix-icon="el-icon-lock" type="password" v-model="ruleForm.password"
                                      :placeholder="$t('account.leave_blank_if_not_modified')"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.trader_password')" prop="payPassword">
                            <el-input prefix-icon="el-icon-key" type="password" v-model="ruleForm.payPassword"
                                      :placeholder="$t('account.input_your_trader_password')"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <div class="btnn bgb texac" @click="submitForm('ruleForm')">{{$t('account.confirm')}}</div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    // @ is an alias to /src
    import {
        getUserInfo, changePassword
    } from '@/api/account.js'

    export default {
        name: 'acSave',
        data() {
            var checkEmail = (rule, value, callback) => {
                let message = ''
                if (value.trim() == "") {
                    //this.$message.error('邮箱不能为空')
                    message = this.$t('account.input_your_email')
                    callback(new Error(message));
                } else if (value.indexOf("@") == -1 || value.indexOf(".") == -1) {
                    //this.$message.error('邮箱格式不正确')
                    message = this.$t('account.email_format_error')
                    callback(new Error(message))
                } else if (value.length < 6) {
                    //this.$message.error('邮箱需大于6位')
                    message = this.$t('account.email_length_error')
                    callback(new Error(message))
                } else {
                    callback();
                }
            };
            var validatePayPass = (rule, value, callback) => {
                let message = ''
                if (value.trim() == "") {
                    //this.$message.error('请输入密码');
                    message = this.$t('account.input_trader_password')
                    callback(new Error(message));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    email: '',
                    password: '',
                    payPassword: ''
                },
                rules: {
                    email: [{
                        validator: checkEmail,
                        trigger: "blur"
                    }],
                    payPassword: [{
                        validator: validatePayPass,
                        trigger: "blur"
                    }]
                }
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        mounted() {
            getUserInfo().then(res => {
                if (res.code == 1) {
                    this.ruleForm.email = res.data.email;
                }


            }).catch(_ => {

            });
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
            submitForm(formName) {
                let that = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        changePassword(this.ruleForm).then(res => {
                            if (res.code == 1) {
                                //that.$router.push('/home/success');
                                this.$message.success(res.msg);
                                this.ruleForm.password = "";
                                this.ruleForm.payPassword = "";
                            } else {
                                this.$message.error(res.msg);
                            }


                        }).catch(_ => {

                        });
                    } else {
                        return false;
                    }
                });
            },
            handleSuccess() {

            },
            handleRemove() {

            }
        }
    }
</script>
<style lang="scss" scoped>
    .acsave {
        font-size: 18px;

        .accctit {
            font-size: 24px;
            font-weight: bold;
            line-height: 80px;
        }

        .tiplin {
            line-height: 40px;
        }

        .marr {
            text-align: center;
            line-height: 26px;

            img {
                width: 200px;
                height: 200px;
                margin-right: 30px;
            }
        }

        .gzimgbox {
            width: 60%;
            margin: 20px auto;
        }

        .examplelistbox {
            img {
                width: 300px;
                height: 600px;
            }
        }

        .formbox {
            width: 60%;
            margin: 30px auto;
            padding: 30px;
            border-radius: 20px;
            border: 1px solid rgb(85, 85, 85);

            .bgb {
                margin: 40px 0px 20px 0px;
                padding: 14px 30px;
                background: #1750cc;
                color: #fff;
                font-size: 20px;
            }
        }
    }
</style>
